import { render, staticRenderFns } from "./olddevview.vue?vue&type=template&id=0bb3431a"
import script from "./olddevview.vue?vue&type=script&lang=js"
export * from "./olddevview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports